import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {SimpleGrid, Text} from '@chakra-ui/react'
import Link from '../../../components/link'
import {normalizeSfccLink} from '../../../utils/url'
import CustomerServiceLayoutDefault from '../layout/default'
import useMultiSite from '../../../hooks/use-multi-site'
import CSHeader from '../partials/header'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import useOcapiSite from '../../../hooks/useOcapiSite'
import DynamicImage from '../../../components/dynamic-image'
import {useIntl} from 'react-intl'

// extract as constant to prevent recalculation on each render
const BRAND_IMAGE_WIDTHS = {
    // 8.5rem = 136px
    base: 136
}

const CustomerServiceUserGuidesOverviewPage = ({brands}) => {
    const {formatMessage} = useIntl()
    const {locale} = useMultiSite()
    const {productFamilyImage} = useOcapiSite()
    const {name, description} = useCustomerServicePageConfig()

    const children = useMemo(
        () =>
            brands?.map((brand, idx) => (
                <Link
                    key={idx}
                    to={normalizeSfccLink(locale.id, brand.link)}
                    display="flex"
                    flexDirection="column"
                    alignItems="stretch"
                    width="8.5rem"
                    textDecor={'none'}
                    gap={4}
                >
                    {productFamilyImage?.[brand.id] && (
                        <DynamicImage
                            src={`${productFamilyImage[brand.id]}[?sw={width}&q=60]`}
                            // update also BRAND_IMAGE_WIDTHS when changing this
                            boxSize="8.5rem"
                            widths={BRAND_IMAGE_WIDTHS}
                            imageProps={{
                                alt: brand.name
                                    ? formatMessage(
                                          {
                                              id: 'customer-service.user-guides.image-alt',
                                              defaultMessage: '{brandName} image'
                                          },
                                          {
                                              brandName: brand.name
                                          }
                                      )
                                    : '',
                                objectFit: 'contain'
                            }}
                        />
                    )}
                    <Text>{brand.name}</Text>
                </Link>
            )),
        [brands, formatMessage, locale.id, productFamilyImage]
    )

    return (
        <CustomerServiceLayoutDefault>
            <CSHeader headline={name} subline={description} />
            <SimpleGrid
                columns={{base: 2, lg: 4}}
                alignItems="flex-start"
                paddingX={4}
                gap={8}
                pb={{base: 2, md: 4}}
            >
                {children}
            </SimpleGrid>
        </CustomerServiceLayoutDefault>
    )
}

CustomerServiceUserGuidesOverviewPage.propTypes = {
    brands: PropTypes.array
}

export default CustomerServiceUserGuidesOverviewPage
